module.exports = __webpack_public_path__ + "media/images/icons/icn_003-8002730a16d61612df429dd6f42943ed.svg";